import { BackofficeRestMutations } from "@/api/backofficeRest/mutations"
import {
  SmartMetersEligibleForExchangeBulkUploadRequest,
  SmartMetersEligibleForExchangeUploadResponse,
} from "@/api/backofficeRest/generated/model"
import { MutationResult } from "@/api/utils/types"
import { useMutation } from "@/api/utils/useQuery"

export interface IBulkSmartMetersEligibleForExchangeUploadMutator {
  upload(): MutationResult<
    SmartMetersEligibleForExchangeBulkUploadRequest,
    SmartMetersEligibleForExchangeUploadResponse
  >
}

class BulkSmartMetersEligibleForExchangeUploadMutatorClass implements IBulkSmartMetersEligibleForExchangeUploadMutator {
  upload(): MutationResult<
    SmartMetersEligibleForExchangeBulkUploadRequest,
    SmartMetersEligibleForExchangeUploadResponse
  > {
    return useMutation({
      ...BackofficeRestMutations.smartMeter.uploadSmartMetersEligibleForExchange(),
      serializerFn: (data: SmartMetersEligibleForExchangeBulkUploadRequest) =>
        data,
      invalidateCache: false,
    })
  }
}

export const BulkSmartMetersEligibleForExchangeUploadMutator =
  new BulkSmartMetersEligibleForExchangeUploadMutatorClass()
